import React from "react";
import logo1 from "../Asset/logo.png";
import logo from "../Asset/logo-w.svg";
import down from "../Asset/down.svg";
import profile from "../Asset/user_pic.png";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { IoIosMenu } from "react-icons/io";
import AuthService from "../Authentication/AuthService";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import "antd/dist/antd.css";
import { Menu, Button } from "antd";
import Role from "../helpers/role";
const { SubMenu } = Menu;

class MMTopPane extends React.Component {
  authService;
  constructor() {
    super();
    this.authService = new AuthService();
    this.state = {
      homeState: true,
      priorityState: false,
      adminState: false,
      show: false,
      currentUser: "",
    };
  }

  componentDidMount() {
    let user1 = localStorage.getItem("UserRoles");
    var _this = this;
    const { history } = this.props;
    _this.authService.getCurrentUserDetails().then(function (user) {
      _this.setState({ currentUser: user });
      _this.props.dispatch({ type: "UserRole", data: user.role });
      _this.props.dispatch({
        type: "AuthenticatedUserInformation",
        data: user,
      });
      if (user1 === "staff") {
        _this.props.dispatch({ type: "ShipRole", data: "Staff" });
      }
    });
  }

  render() {
    const { userDetail, equipmentInfo, history } = this.props;
    const { currentUser } = this.state;
    let user = localStorage.getItem("UserRoles");
    console.log("padja", window.location.pathname)
    return (
      <>
        {/* {window.location.pathname == "/Home/MMPlDashboard" || window.location.pathname == "/Home/MMPLDashboard" || window.location.pathname.includes("/Home/MMPLDashboardClient/") ?        */}
        <div className="app-hheader">
          {/* <div className='collapse show label'>
                  <span>System </span>
                  <span>|  </span>
                  <span>Account</span>
              </div> */}
          <div className="site-hheader-inner">
            <div
              className="row wid100 ml-0"
              style={{ maxWidth: "100%", flex: "0 0 100%" }}>
              <div className="col-sm6 col-4 p0 m-0">
                <a
                  href="#"
                  style={{ margin: "0rem 0rem 0rem 0rem" }}
                  className="logo-outer"
                  onClick={() => {
                    history.push("/");
                  }}
                >
                  <img className="logo-imagenav" src={logo}></img>
                </a>
                <span class="ihmmainten">IHM Maintenance</span>
              </div>
              <div
                className="col-sm6 m-auto padd"
                data-toggle="collapse"
                data-target="#main_nav">
                <IoIosMenu
                  onClick={(e) => this.setState({ show: !this.state.show })}
                  style={{ width: "40px", height: "40px", float: "right" }}
                  className="do menu"
                />
              </div>
              <nav className="navbar-expand-lg h-menu col-4 text-center">
                <div className="h-menu navbar-collapse">
                  <ul className="navbar-nav m-auto">
                    {user == Role.client ? (
                      <li className={this.state.homeState == true ? "nav-item nav-menu-item nav-cls-in active" : "nav-item nav-menu-item nav-cls-in"}>
                        <a
                          className="nav-link discover navstyle navigation_zone"
                          onClick={(e) => this.ClientDashboardNavigation(e)}
                          href="/Home/ClientDashboard"
                        >
                          Home
                        </a>
                      </li>
                    ) : null}
                    {user == Role.consultant ? (
                      <li className={this.state.homeState == true ? "nav-item nav-menu-item nav-cls-in active" : "nav-item nav-menu-item nav-cls-in"}>
                        <a
                          className="nav-link discover navstyle navigation_zone"
                          onClick={(e) => this.ConsultantDashboardNavigation(e)}
                          href="/Home/ClientDashboard"
                        >
                          Home
                        </a>
                      </li>
                    ) : null}

                    {user == Role.mmpladmin || user == Role.mmpl ? (
                      <li className={this.state.homeState == true ? "nav-item nav-menu-item nav-cls-in active" : "nav-item nav-menu-item nav-cls-in"}>
                        <a
                          className="nav-link discover navstyle navigation_zone"
                          onClick={(e) => this.MMPLDashboardNavigation(e)}
                          href="/Home/MMPLDashboard"
                        >
                          Home
                        </a>
                      </li>
                    ) : null}

                    {user == Role.mmpladmin || user == Role.mmpl ? (
                      <li className={this.state.priorityState == true ? "nav-item nav-menu-item nav-cls-in active" : "nav-item nav-menu-item nav-cls-in"}>
                        <a
                          className="nav-link discover navstyle navigation_zone"
                          onClick={(e) => this.PriorityDashboardNavigation(e)}
                          href="/Home/PriorityDashboard"
                        >
                          Priority List
                        </a>
                      </li>
                    ) : null}

                    {user == Role.staff ? (
                      <li className={this.state.homeState == true ? "nav-item nav-menu-item nav-cls-in active" : "nav-item nav-menu-item nav-cls-in"}>
                        <a
                          className="nav-link discover navstyle navigation_zone"
                          onClick={(e) => this.ShipViewNavigation(e)}
                          href="/Home/Ship/Staff/Tasks"
                        >
                          Home
                        </a>
                      </li>
                    ) : null}

                    {/* {user == Role.mmpl ?
                                     <ul className="navbar-nav m-auto">
                                      <li className="nav-item nav-menu-item nav-cls-in">
                                          <a className="nav-link discover navstyle" onClick={this.MMPLDashboardNavigation} href="#">
                                              Home
                                          </a>
                                      </li>
                                      <li className="nav-item nav-menu-item nav-cls-in">
                                          <a className="nav-link discover navstyle" onClick={this.MDNavigation} href="#">
                                          MD Library
                                          </a>
                                      </li>
                                      <li className="nav-item nav-menu-item nav-cls-in">
                                          <a className="nav-link discover navstyle" onClick={this.SMDNavigation} href="#">
                                          SMD Library
                                          </a>
                                      </li>
                                      </ul>
                                      : null} */}

                    {user == Role.mmpladmin || user == Role.mmpl ? (
                      <li class={this.state.adminState == true ? "nav-item dropdown nav-menu-item nav-cls-in active" : "nav-item dropdown nav-menu-item nav-cls-in"}>
                        {user == Role.mmpladmin ? (
                          <a
                            class="nav-link dropdown-toggle discover navstyle navigation_zone"
                            href="#"
                            id="navbarDropdownMenuLink"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            {" "}
                            Admin{" "}
                          </a>
                        ) : null}
                        {user == Role.mmpl ? (
                          <a
                            class="nav-link dropdown-toggle discover navstyle"
                            href="#"
                            id="navbarDropdownMenuLink"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            {" "}
                            MMPL{" "}
                          </a>
                        ) : null}
                        <ul
                          class="dropdown-menu"
                          aria-labelledby="navbarDropdownMenuLink"
                          style={{
                            transform: "translate3d(0px, 35px, 0px)",
                            position: "absolute",
                            willChange: "transform",
                            top: "0px",
                            left: "0px",
                          }}
                        >
                          {user == Role.mmpladmin || user == Role.mmpl ? (
                            <li onClick={(e) => this.MDNavigation(e)}>
                              <a class="dropdown-item" href="/Home/MDLibrary">
                                MD Library
                              </a>
                            </li>
                          ) : null}
                          {user == Role.mmpladmin || user == Role.mmpl ? (
                            <li onClick={(e) => this.SMDNavigation(e)}>
                              <a class="dropdown-item" href="/Home/SMDLibray">
                                SDoC Library
                              </a>
                            </li>
                          ) : null}
                          {user == Role.mmpladmin || user == Role.mmpl ? (
                            <li onClick={(e) => this.MDSDUploadNav(e)}>
                              <a class="dropdown-item" href="/Home/MdocSdocUpload">
                                MD & SDoC Upload
                              </a>
                            </li>
                          ) : null}
                          {user == Role.mmpladmin || user == Role.mmpl ? (
                            <li onClick={(e) => this.GDNavigation(e)}>
                              <a class="dropdown-item" href="/Home/GDLibray">
                                GD Library
                              </a>
                            </li>
                          ) : null}
                          {user == Role.mmpladmin || user == Role.mmpl ? (
                            <li onClick={(e) => this.ReportNavigation(e)}>
                              <a class="dropdown-item" href="/Home/Report">
                                Reports
                              </a>
                            </li>
                          ) : null}
                          {/* {user == Role.mmpladmin ? <li onClick={this.UserNavigation}><a class="dropdown-item" href="#">MMPL User Management</a></li> : null} */}
                          {user == Role.mmpladmin || user == Role.mmpl ? (
                            <li onClick={(e) => this.ShipManagementNavigation(e)}>
                              <a
                                class="dropdown-item"
                                href="/Home/Management/Ship"
                              >
                                Ship Management
                              </a>
                            </li>
                          ) : null}
                          {/* {user == Role.mmpladmin ? <li onClick={this.ClientManagementNavigation}><a class="dropdown-item" href="#">Client Management</a></li> : null} */}
                          {/* {user == Role.mmpladmin ? <li onClick={this.StaffManagementNavigation}><a class="dropdown-item" href="#">Staff Management</a></li> : null} */}
                          {user == Role.mmpladmin || user == Role.mmpl ? (
                            <li
                              onClick={(e) => this.KeywordManagementNavigation(e)}
                            >
                              <a
                                class="dropdown-item"
                                href="/Home/Management/Keyword"
                              >
                                Keyword Management
                              </a>
                            </li>
                          ) : null}
                          {user == Role.mmpladmin || user == Role.mmpl ? (
                            <li
                              onClick={(e) => this.POSyncManagementNavigation(e)}
                            >
                              <a
                                class="dropdown-item"
                                href="/Home/Management/POSyncException"
                              >
                                Po Sync Exceptions
                              </a>
                            </li>
                          ) : null}
                          {user == Role.mmpladmin || user == Role.mmpl ? (
                            <li
                              onClick={(e) => this.ExistKeywordManagementNavigation(e)}
                            >
                              <a
                                class="dropdown-item"
                                href="/Home/Management/ExistKeyword"
                              >
                                Existing Keyword Management
                              </a>
                            </li>
                          ) : null}
                          {user == Role.mmpladmin || user == Role.mmpl ? (
                            <li
                              onClick={(e) =>
                                this.ExceptionManagementNavigation(e)
                              }
                            >
                              <a
                                class="dropdown-item"
                                href="/Home/Management/Exception"
                              >
                                Exception Management
                              </a>
                            </li>
                          ) : null}
                          {user == Role.mmpladmin || user == Role.mmpl ? (
                            <li onClick={(e) => this.KPYDashboardNavigation(e)}>
                              <a class="dropdown-item" href="/Home/KPIDashboard">
                                KPI Dashboard
                              </a>
                            </li>
                          ) : null}
                          {user == Role.mmpladmin || user == Role.mmpl ? (
                            <li
                              onClick={(e) => this.POSyncDashboardNavigation(e)}
                            >
                              <a
                                class="dropdown-item"
                                href="/Home/Management/POSyncDashboard"
                              >
                                Po Sync Dashboard
                              </a>
                            </li>
                          ) : null}
                          {user == Role.mmpladmin ? (
                            <li className="dropdown-submenu">
                              <a
                                className="dropdown-item dropdown-toggle"
                                href="#"
                              >
                                User Management
                              </a>
                              <ul className="dropdown-menu">
                                <li onClick={(e) => this.UserNavigation(e)}>
                                  <a
                                    className="dropdown-item"
                                    href="/Home/Management/User"
                                  >
                                    MMPL
                                  </a>
                                </li>
                                <li
                                  onClick={(e) =>
                                    this.ClientManagementNavigation(e)
                                  }
                                >
                                  <a
                                    className="dropdown-item"
                                    href="/Home/Management/Client"
                                  >
                                    Client
                                  </a>
                                </li>
                                <li
                                  onClick={(e) =>
                                    this.FleetManagerNavigation(e)
                                  }
                                >
                                  <a
                                    className="dropdown-item"
                                    href="/Home/Management/FleetManager"
                                  >
                                    Fleet Manager
                                  </a>
                                </li>
                                <li
                                  onClick={(e) =>
                                    this.TechSuperintendentNavigation(e)
                                  }
                                >
                                  <a
                                    className="dropdown-item"
                                    href="/Home/Management/TechSuperintendent"
                                  >
                                    Technical Superintendent
                                  </a>
                                </li>
                                <li
                                  onClick={(e) =>
                                    this.TechExecutiveNavigation(e)
                                  }
                                >
                                  <a
                                    className="dropdown-item"
                                    href="/Home/Management/TechExecutive"
                                  >
                                    Technical Executive
                                  </a>
                                </li>
                                <li
                                  onClick={(e) =>
                                    this.StaffManagementNavigation(e)
                                  }
                                >
                                  <a
                                    className="dropdown-item"
                                    href="/Home/Management/Staff"
                                  >
                                    Ship Staff
                                  </a>
                                </li>
                                <li
                                  onClick={(e) =>
                                    this.SpecialAccessManagementNavigation(e)
                                  }
                                >
                                  <a
                                    className="dropdown-item"
                                  // href="/Home/Management/SpecialAccess"
                                  >
                                    Special Access
                                  </a>
                                </li>
                              </ul>
                            </li>
                          ) : null}
                        </ul>
                      </li>
                    ) : null}
                  </ul>
                </div>
              </nav>
              <div className="col-2"></div>
              {userDetail ? (
                <div className="ng-star-inserted h-menu col-2 text-right">
                  <div className="mt-0 pro-nav">
                    <UncontrolledDropdown>
                      <DropdownToggle nav caret>
                        {this.UserAvatar(userDetail)}
                        <span className="navstyle">
                          {userDetail.name.split("@")[0]}
                          <img className="down-icon" src={down}></img>
                        </span>
                      </DropdownToggle>
                      <DropdownMenu right>
                        <h5 className="dropdown-item-text mb-0">
                          {userDetail.name.split("@")[0]}
                        </h5>
                        <p className="dropdown-item-text text-muted mb-0">
                          {userDetail.email}
                        </p>
                        {/* <a href="" className="dropdown mb-0 pl-4" onClick={() => this.changePassword()}>Change Password</a> */}
                        <DropdownItem divider />
                        <DropdownItem onClick={() => this.changePassword()}>
                          Change Password
                        </DropdownItem>
                        <DropdownItem onClick={() => this.logout()}>
                          Sign Out
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          {this.state.show ? (
            <div
              className="collapse navbar-collapse show menu-item"
              id="main_nav"
            >
              <Menu
                onClick={this.handleClick}
                style={{ width: "100%", borderRight: "none", marginTop: "20px" }}
                defaultSelectedKeys={["1"]}
                // defaultOpenKeys={['sub1']}
                mode="inline"
              >
                <ul className="navbar-nav m-auto">
                  {user == Role.client ? (
                    <li className={this.state.homeState == true ? "nav-item nav-menu-item nav-cls-in active" : "nav-item nav-menu-item nav-cls-in"}>
                      {/* <a className="nav-link discover navstyle" onClick={this.ClientDashboardNavigation} href="#" >
                                          Home
                                          </a> */}
                      <Menu.Item
                        key="M1"
                        className="navstyle space mobile-menu mobile-menu navigation_zone pl-1"
                        onClick={this.ClientDashboardNavigation}
                      >
                        Home
                      </Menu.Item>
                    </li>
                  ) : null}
                  {user == Role.consultant ? (
                    <li className={this.state.homeState == true ? "nav-item nav-menu-item nav-cls-in active" : "nav-item nav-menu-item nav-cls-in"}>
                      {/* <a className="nav-link discover navstyle" onClick={this.ClientDashboardNavigation} href="#" >
                                          Home
                                          </a> */}
                      <Menu.Item
                        key="M1"
                        className="navstyle space mobile-menu mobile-menu navigation_zone pl-1"
                        onClick={this.ConsultantDashboardNavigation}
                      >
                        Home
                      </Menu.Item>
                    </li>
                  ) : null}

                  {user == Role.mmpl || user == Role.mmpladmin ? (
                    <li className={this.state.homeState == true ? "nav-item nav-menu-item nav-cls-in active" : "nav-item nav-menu-item nav-cls-in"}>
                      {/* <a className="nav-link discover navstyle" onClick={this.MMPLDashboardNavigation} href="#">
                                          Home
                                          </a> */}
                      <Menu.Item
                        key="M1"
                        className="navstyle space mobile-menu navigation_zone pl-1"
                        onClick={this.MMPLDashboardNavigation}
                      >
                        Home
                      </Menu.Item>
                    </li>
                  ) : null}

                  {user == Role.staff ? (
                    <li className={this.state.homeState == true ? "nav-item nav-menu-item nav-cls-in active " : "nav-item nav-menu-item nav-cls-in"}>
                      {/* <a className="nav-link discover navstyle" onClick={this.ShipViewNavigation} href="#">
                                          Home
                                          </a> */}
                      <Menu.Item
                        key="M1"
                        className="navstyle space mobile-menu navigation_zone pl-1"
                        onClick={this.ShipViewNavigation}
                      >
                        Home
                      </Menu.Item>
                    </li>
                  ) : null}

                  {user == Role.mmpladmin || user == Role.mmpl ? (
                    <li class="nav-item dropdown nav-menu-item pl-4">
                      <a
                        class="nav-link dropdown-toggle discover  navstyle navigation_zone color-title"
                        style={{ paddingLeft: "24px" }}
                        href="#"
                        id="navbarDropdownMenuLink"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        {" "}
                        Admin{" "}
                      </a>
                      <ul
                        class="dropdown-menu"
                        aria-labelledby="navbarDropdownMenuLink"
                      >
                        {user == Role.mmpladmin || user == Role.mmpl ? (
                          <li>
                            <Menu.Item
                              key="M1"
                              className="navstyle space mobile-menu"
                              onClick={this.MDNavigation}
                            >
                              MD Library
                            </Menu.Item>
                          </li>
                        ) : null}
                        {user == Role.mmpladmin || user == Role.mmpl ? (
                          <li>
                            <Menu.Item
                              key="M2"
                              className="navstyle space mobile-menu"
                              onClick={this.SMDNavigation}
                            >
                              SDoC Library
                            </Menu.Item>
                          </li>
                        ) : null}
                        {user == Role.mmpladmin || user == Role.mmpl ? (
                          <li>
                            <Menu.Item
                              key="M2"
                              className="navstyle space mobile-menu"
                              onClick={this.MDSDUploadNav}
                            >
                              MD & SDoC Upload
                            </Menu.Item>
                          </li>
                        ) : null}
                        {user == Role.mmpladmin || user == Role.mmpl ? (
                          <li>
                            <Menu.Item
                              key="M2"
                              className="navstyle space mobile-menu"
                              onClick={this.GDNavigation}
                            >
                              GD Library
                            </Menu.Item>
                          </li>
                        ) : null}
                        {user == Role.mmpladmin || user == Role.mmpl ? (
                          <li>
                            <Menu.Item
                              key="M3"
                              className="navstyle space mobile-menu"
                              onClick={this.ReportNavigation}
                            >
                              Reports
                            </Menu.Item>
                          </li>
                        ) : null}
                        {user == Role.mmpladmin ? (
                          <li>
                            <Menu.Item
                              key="M4"
                              className="navstyle space mobile-menu"
                              onClick={this.UserNavigation}
                            >
                              MMPL User Management
                            </Menu.Item>
                          </li>
                        ) : null}
                        {user == Role.mmpladmin || user == Role.mmpl ? (
                          <li>
                            <Menu.Item
                              key="M5"
                              className="navstyle space mobile-menu"
                              onClick={this.ShipManagementNavigation}
                            >
                              Ship Management
                            </Menu.Item>
                          </li>
                        ) : null}
                        {user == Role.mmpladmin ? (
                          <li>
                            <Menu.Item
                              key="M6"
                              className="navstyle space mobile-menu"
                              onClick={this.ClientManagementNavigation}
                            >
                              Client Management
                            </Menu.Item>
                          </li>
                        ) : null}
                        {user == Role.mmpladmin ? (
                          <li>
                            <Menu.Item
                              key="M7"
                              className="navstyle space mobile-menu"
                              onClick={this.StaffManagementNavigation}
                            >
                              Staff Management
                            </Menu.Item>
                          </li>
                        ) : null}
                        {user == Role.mmpladmin || user == Role.mmpl ? (
                          <li>
                            <Menu.Item
                              key="M8"
                              className="navstyle space mobile-menu"
                              onClick={this.KeywordManagementNavigation}
                            >
                              Keyword Management
                            </Menu.Item>
                          </li>
                        ) : null}
                        {user == Role.mmpladmin || user == Role.mmpl ? (
                          <li>
                            <Menu.Item
                              key="M11"
                              className="navstyle space mobile-menu"
                              onClick={this.POSyncManagementNavigation}
                            >
                              Po Sync Exceptions
                            </Menu.Item>
                          </li>
                        ) : null}
                        {user == Role.mmpladmin || user == Role.mmpl ? (
                          <li>
                            <Menu.Item
                              key="M11"
                              className="navstyle space mobile-menu"
                              onClick={this.POSyncDashboardNavigation}
                            >
                              Po Sync Dashboard
                            </Menu.Item>
                          </li>
                        ) : null}

                        {user == Role.mmpladmin || user == Role.mmpl ? (
                          <li>
                            <Menu.Item
                              key="M10"
                              className="navstyle space mobile-menu"
                              onClick={this.ExistKeywordManagementNavigation}
                            >
                              Existing Keyword Management
                            </Menu.Item>
                          </li>
                        ) : null}
                        {user == Role.mmpladmin || user == Role.mmpl ? (
                          <li>
                            <Menu.Item
                              key="M9"
                              className="navstyle space mobile-menu"
                              onClick={this.ExceptionManagementNavigation}
                            >
                              Exception Management
                            </Menu.Item>
                          </li>
                        ) : null}
                      </ul>
                    </li>
                  ) : null}
                </ul>
                {/* </div> */}
                {/* </nav> */}
                {/* <Menu.Item key="M1" className="navstyle space" onClick={this.MDNavigation}>MD Library</Menu.Item>
                          <Menu.Item key="M2" className="navstyle space" onClick={this.SMDNavigation}>SMD Library</Menu.Item>
                          <Menu.Item key="M3" className="navstyle space" onClick={this.ReportNavigation}>Reports</Menu.Item>
                          <Menu.Item key="M4" className="navstyle space" onClick={this.UserNavigation}>MMPL User Management</Menu.Item>
                          <Menu.Item key="M5" className="navstyle space" onClick={this.ShipViewNavigation}>Staff View</Menu.Item> */}
                {/* <Menu.Item key="M6" className="navstyle space" onClick={this.Certificates}>Certificates</Menu.Item> */}
                {/* <Menu.Item key="M7" className="navstyle space" onClick={this.MaintenanceRevision}>IHM Maintenance Revision</Menu.Item> */}
                {/* <Menu.Item key="M8" className="navstyle space" onClick={this.HazardessMaterial}>PO Hazardess</Menu.Item> */}
                <Menu.Item
                  key="M9"
                  className="navstyle space"
                  style={{ color: "#ae1916", textDecoration: "underline" }}
                  onClick={() => this.logout()}
                >
                  {userDetail.name} (Sign Out)
                </Menu.Item>
                <Menu.Item
                  key="M9"
                  className="navstyle space"
                  style={{ color: "#ae1916", textDecoration: "underline" }}
                  onClick={() => this.changePassword()}
                >
                  Change Password
                </Menu.Item>
              </Menu>
            </div>
          ) : null}
        </div>
      </>

    );
  }

  logout() {
    this.authService.logout();
    // this.props.history.push("/logout");
  }

  changePassword = () => {
    this.props.history.push("/Home/ChangePassword");
    this.setState({ show: false });
  };

  UserAvatar(user) {
    return (
      <>
        {/* {window.location.pathname == "/Home/MMPlDashboard" || window.location.pathname == "/Home/MMPLDashboard" || window.location.pathname.includes("/Home/MMPLDashboardClient/") ?  */}
        <span className="profile-icon-main"> <img className="profile-icon" src={profile} width={43} height={43}></img></span>
        {/* : */}
        {/* <i
        className="fa fa-user-circle fa-lg rounded-circle align-self-center mr-1"
        style={{ width: "32px", display: "content" }}
      ></i>  */}

      </>
    );
  }

  SMDNavigation = (e) => {
    this.state.homeState = false;
    this.state.priorityState = false;
    this.state.adminState = true;
    this.props.dispatch({ type: "Otherpages" });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "SDoC LIBRARY" });
    this.props.history.push("/Home/SMDLibray");
    this.props.dispatch({ type: "EditPOView", data: false });
    // this.props.dispatch({ type: "POSuccess", data: ""});
    // this.props.dispatch({ type: "searchSuccess", data: "" });
    e.preventDefault();
  };
  MDSDUploadNav = (e) => {
    this.state.homeState = false;
    this.state.priorityState = false;
    this.state.adminState = true;
    this.props.dispatch({ type: "Otherpages" });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "MD & SDoC Upload" });
    this.props.history.push("/Home/MdocSdocUpload");
    this.props.dispatch({ type: "EditPOView", data: false });
    // this.props.dispatch({ type: "POSuccess", data: ""});
    // this.props.dispatch({ type: "searchSuccess", data: "" });
    e.preventDefault();
  };

  GDNavigation = (e) => {
    this.state.homeState = false;
    this.state.priorityState = false;
    this.state.adminState = true;
    this.props.dispatch({ type: "Otherpages" });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "GD Library" });
    this.props.history.push("/Home/GDLibray");
    this.props.dispatch({ type: "EditPOView", data: false });
    // this.props.dispatch({ type: "POSuccess", data: ""});
    // this.props.dispatch({ type: "searchSuccess", data: "" });
    e.preventDefault();
  };

  MDNavigation = (e) => {
    this.state.homeState = false;
    this.state.priorityState = false;
    this.state.adminState = true;
    this.props.dispatch({ type: "MDDetail" });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "MD Library" });
    this.props.history.push("/Home/MDLibrary");
    this.props.dispatch({ type: "EditPOView", data: false });
    // this.props.dispatch({ type: "POSuccess", data: ""});
    // this.props.dispatch({ type: "searchSuccess", data: "" });
    e.preventDefault();
  };

  ReportNavigation = (e) => {
    this.state.homeState = false;
    this.state.priorityState = false;
    this.state.adminState = true;
    this.props.dispatch({ type: "Otherpages" });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Reports" });
    this.props.history.push("/Home/Report");
    this.props.dispatch({ type: "EditPOView", data: false });
    // this.props.dispatch({ type: "POSuccess", data: ""});
    // this.props.dispatch({ type: "searchSuccess", data: "" });
    e.preventDefault();
  };

  UserNavigation = (e) => {
    this.state.homeState = false;
    this.state.priorityState = false;
    this.state.adminState = true;
    // this.props.dispatch({ type: 'User', data: false })
    this.props.dispatch({ type: "Otherpages" });
    this.setState({ show: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({
      type: "SubBannerTitle",
      data: "MMPL User Management",
    });
    this.props.history.push("/Home/Management/User");
    this.props.dispatch({ type: "EditPOView", data: false });
    // this.props.dispatch({ type: "POSuccess", data: ""});
    // this.props.dispatch({ type: "searchSuccess", data: "" });
    e.preventDefault();
  };

  ShipViewNavigation = (e) => {
    this.state.homeState = true;
    this.state.priorityState = false;
    this.state.adminState = false;
    this.props.dispatch({ type: "EditPOView", data: false });
    this.setState({ show: false });
    this.props.dispatch({ type: "ShowPODetail", data: false });
    this.props.dispatch({ type: "EditPendingTaskRevision", data: false });
    this.props.dispatch({ type: "EditPendingTaskPresence", data: false });
    this.props.dispatch({ type: "Otherpages" });
    this.props.history.push(`/Home/Ship/Staff/Tasks`);
    // this.props.dispatch({ type: "searchSuccess", data: "" });
    e.preventDefault();
  };
  ShipManagementNavigation = (e) => {
    this.state.homeState = false;
    this.state.priorityState = false;
    this.state.adminState = true;
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Ship Management" });
    this.props.history.push(`/Home/Management/Ship`);
    // this.props.dispatch({ type: "POSuccess", data: ""});
    // this.props.dispatch({ type: "searchSuccess", data: "" });
    e.preventDefault();
  };
  ClientManagementNavigation = (e) => {
    this.state.homeState = true;
    this.state.priorityState = false;
    this.state.adminState = false;
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Client Management" });
    this.props.history.push(`/Home/Management/Client`);
    // this.props.dispatch({ type: "POSuccess", data: ""});
    // this.props.dispatch({ type: "searchSuccess", data: "" });
    e.preventDefault();
  };
  StaffManagementNavigation = (e) => {
    this.state.homeState = false;
    this.state.priorityState = false;
    this.state.adminState = true;
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Staff Management" });
    this.props.history.push(`/Home/Management/Staff`);
    // this.props.dispatch({ type: "POSuccess", data: ""});
    // this.props.dispatch({ type: "searchSuccess", data: "" });
    e.preventDefault();
  };
  FleetManagerNavigation = (e) => {
    this.state.homeState = false;
    this.state.priorityState = false;
    this.state.adminState = true;
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Fleet Manager" });
    this.props.history.push(`/Home/Management/FleetManager`);
    // this.props.dispatch({ type: "POSuccess", data: ""});
    // this.props.dispatch({ type: "searchSuccess", data: "" });
    e.preventDefault();
  };
  TechSuperintendentNavigation = (e) => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Technical Superintendent" });
    this.props.history.push(`/Home/Management/TechSuperintendent`);
    // this.props.dispatch({ type: "POSuccess", data: ""});
    // this.props.dispatch({ type: "searchSuccess", data: "" });
    e.preventDefault();
  };
  TechExecutiveNavigation = (e) => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Technical Executive" });
    this.props.history.push(`/Home/Management/TechExecutive`);
    // this.props.dispatch({ type: "POSuccess", data: ""});
    // this.props.dispatch({ type: "searchSuccess", data: "" });
    e.preventDefault();
  };
  SpecialAccessManagementNavigation = (e) => {
    this.state.homeState = false;
    this.state.priorityState = false;
    this.state.adminState = true;
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({
      type: "SubBannerTitle",
      data: "Special Access Management",
    });
    this.props.history.push(`/Home/Management/SpecialAccess`);
    // this.props.dispatch({ type: "POSuccess", data: ""});
    // this.props.dispatch({ type: "searchSuccess", data: "" });
    e.preventDefault();
  };
  KeywordManagementNavigation = (e) => {
    this.state.homeState = false;
    this.state.priorityState = false;
    this.state.adminState = true;
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Keyword Management" });
    this.props.history.push(`/Home/Management/Keyword`);
    // this.props.dispatch({ type: "POSuccess", data: ""});
    // this.props.dispatch({ type: "searchSuccess", data: "" });
    e.preventDefault();
  };
  ExistKeywordManagementNavigation = (e) => {
    this.state.homeState = false;
    this.state.priorityState = false;
    this.state.adminState = true;
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Existing Keyword Management" });
    this.props.history.push(`/Home/Management/ExistKeyword`);
    e.preventDefault();
  };
  POSyncManagementNavigation = (e) => {
    this.state.homeState = false;
    this.state.priorityState = false;
    this.state.adminState = true;
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Po Sync Exceptions" });
    this.props.history.push(`/Home/Management/POSyncException`);
    e.preventDefault();
  };
  POSyncDashboardNavigation = (e) => {
    this.state.homeState = false;
    this.state.priorityState = false;
    this.state.adminState = true;
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Po Sync Dashboard" });
    this.props.history.push(`/Home/Management/POSyncDashboard`);
    e.preventDefault();
  };

  ExceptionManagementNavigation = (e) => {
    this.state.homeState = false;
    this.state.priorityState = false;
    this.state.adminState = true;
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.setState({ show: false });
    this.props.dispatch({
      type: "SubBannerTitle",
      data: "Exception Management",
    });
    this.props.history.push(`/Home/Management/Exception`);
    // this.props.dispatch({ type: "POSuccess", data: ""});
    // this.props.dispatch({ type: "searchSuccess", data: "" });
    e.preventDefault();
  };
  ClientDashboardNavigation = (e) => {
    this.state.homeState = true;
    this.state.priorityState = false;
    this.state.adminState = false;
    this.props.dispatch({ type: "Otherpages" });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Dashboard" });
    this.props.history.push("/Home/ClientDashboard");
    this.props.dispatch({ type: "shipClientSuccess", data: "" });
    e.preventDefault();
  };
  ConsultantDashboardNavigation = (e) => {
    this.state.homeState = true;
    this.state.priorityState = false;
    this.state.adminState = false;
    this.props.dispatch({ type: "Otherpages" });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Dashboard" });
    this.props.history.push("/Home/SpecialAccess");
    this.props.dispatch({ type: "shipClientSuccess", data: "" });
    e.preventDefault();
  };

  KPYDashboardNavigation = (e) => {
    this.state.homeState = false;
    this.state.priorityState = false;
    this.state.adminState = true;
    this.props.dispatch({ type: "Otherpages" });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "KPI Dashboard" });
    this.props.history.push("/Home/KPIDashboard");
    this.props.dispatch({ type: "shipClientSuccess", data: "" });
    e.preventDefault();
  };

  MMPLDashboardNavigation = (e) => {
    this.state.homeState = true;
    this.state.priorityState = false;
    this.state.adminState = false;
    this.props.dispatch({ type: "Otherpages" });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Dashboard" });
    this.props.history.push("/Home/MMPLDashboard");
    this.props.dispatch({ type: "POSuccess", data: "" });
    this.props.dispatch({ type: "searchSuccess", data: "" });
    e.preventDefault();
  };

  PriorityDashboardNavigation = (e) => {
    this.state.homeState = false;
    this.state.priorityState = true;
    this.state.adminState = false;
    this.props.dispatch({ type: "Otherpages" });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Priority List" });
    this.props.history.push("/Home/PriorityDashboard");
    this.props.dispatch({ type: "shipClientSuccess", data: "" });
    e.preventDefault();
  };
}

function mapStateToProps(state) {
  return {
    userDisplayName: state.SidePanReducer.userDisplayName,
    userDetail: state.SidePanReducer.userDetail,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MMTopPane)
);
